export const EMAIL_CUSTOMER_SUPPORT = 'aip@corrpro.com';
export const EMAIL_AV_PRIMARY_DEV = 'aip@corrpro.com';
